<template lang="pug">
.BaseSingleSelect
  .select_item(
    v-for="(option, i) in optionList",
    :key="i",
    :class="{ checked: checked === option, hasMarginBottom: hasMarginBottom }",
    @click="choose(option)"
  ) {{ option }}
  slot
</template>

<script>
export default {
  props: {
    optionList: {
      type: Array
    },
    checked: {
      type: String
    },
    hasMarginBottom: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
    choose (option) {
      this.$emit('update:checked', option)
      this.$emit('changed', option)
    }
  }
}
</script>

<style lang="scss" scoped>
.BaseSingleSelect {
  width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .select_item {
    white-space: nowrap;
    height: 34px;
    line-height: 34px;
    padding: 0 18px;
    margin-right: 14px;
    font-size: 14px;
    color: #666666;
    cursor: pointer;
    &.hasMarginBottom {
      margin-bottom: 24px;
    }
    &.checked {
      background-color: #347eee;
      border-radius: 6px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/BaseSingleSelect.vue